export const setInitialFormValues = <T, TInitial extends any>(prop: T | null, initialValue?: TInitial): T | TInitial =>
  prop === null || prop === undefined ? (initialValue as TInitial) : prop;

export const setInitialStringValue = <T>(prop: T, initialValue: string): string =>
  typeof prop !== 'string' ? initialValue : prop;
